import type { ApprovalFlowInvoiceTypes } from '@vy/api-definition';
import {
  GetApprovalFlowInvoicesListResponseSchema,
  type GetApprovalFlowInvoicesListResponse,
} from '@vy/api-definition';
import { vySerialize } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useGetApprovalFlowInvoicesList(
  invoiceTypes: ApprovalFlowInvoiceTypes[],
  options?: CustomUseQueryOptions<GetApprovalFlowInvoicesListResponse>,
) {
  return useQuery(
    queryKeys.approvalFlowInvoicesList(invoiceTypes),
    async () => {
      const privateApi = getPrivateApi();
      const stringifiedInvoiceTypes = vySerialize(invoiceTypes);

      const approvalFlowInvoicesList = await privateApi.getApprovalFlowInvoicesList({
        invoiceTypes: stringifiedInvoiceTypes,
      });

      return GetApprovalFlowInvoicesListResponseSchema.parse(approvalFlowInvoicesList);
    },
    options,
  );
}
